import useAppDispatch from "@/hooks/useAppDispatch";
import wooStoreApiService from "@/api/services/wooStoreApiService";
import { handleApiError } from "@/helpers/apiErrorHelper";
import { type OrderData } from "@/types/checkout";
import type {
  SubmitOrderForCVSShippingRequestPayload,
  SubmitOrderForPostShippingRequestPayload,
} from "@/types/api/wooStoreApi";

//#region type
interface UseCheckoutReturn {
  submitCheckoutOrder: (payload: any) => Promise<OrderData | undefined>;
}
//#endregion

const useCheckout = (): UseCheckoutReturn => {
  const appDispatch = useAppDispatch();

  const submitCheckoutOrder = async (
    payload: SubmitOrderForCVSShippingRequestPayload | SubmitOrderForPostShippingRequestPayload,
  ) => {
    try {
      const { data: order } = await wooStoreApiService.checkout.submitOrder(payload);
      return order;
    } catch (error) {
      handleApiError(error, appDispatch, "送出訂單發生錯誤，請稍後再試一次");
    }
  };

  return {
    submitCheckoutOrder,
  };
};

export default useCheckout;
